import * as go from 'gojs';
import { GOJS_CUSTOM_FIGURES } from '../utils/custom-figure-generator';

const $ = go.GraphObject.make;

export const roundedRightRectangle = (props: Record<string, unknown> = {}, bindings: go.Binding[] = []) =>
  $(
    go.Shape,
    {
      figure: GOJS_CUSTOM_FIGURES.RoundedRightRectangle,
      spot1: go.Spot.TopLeft,
      spot2: go.Spot.BottomRight,
      stroke: null,
      strokeWidth: 2,
      fill: 'white',
      ...props,
    },
    ...bindings,
  );
